import { ApiService } from "../..";

export const updateFeedbackReplyState = (data: { reply: boolean }, feedbackId: string) => {
  return ApiService.baseAction(
    `feedback/${feedbackId}/update`,
    {
      data,
    },
    "post"
  );
};
